export { default } from './dist/vue-blockui.common'
export * from './dist/vue-blockui.common'
import './dist/vue-blockui.css'



//////////////////
// WEBPACK FOOTER
// ./~/vue-blockui/index.js
// module id = KVzY
// module chunks = 0